(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("accessDenied", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/security/accessDeniedView.html"
        };
    });
}());
